// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PgdM","newExpiryDate":"styles_newExpiryDate__xOnUj","footer":"styles_footer__2g8iA"};